<template>
  <div v-if="goodsList && goodsList.length > 0" class="goods-list-container">
    <div class="title">积分兑好礼</div>
    <div class="goods-wrap">
      <good-item
        v-for="(item, index) in goodsList"
        :key="index"
        :goods-item="item"
        class="goods-item"
        @pointGoodsExchange="onPointGoodsExchange"
      />
    </div>
  </div>
</template>

<script>
import GoodItem from './GoodItem.vue'
export default {
  components: {
    GoodItem
  },
  props: {
    goodsList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onPointGoodsExchange(goodsItem) {
      this.$emit('pointGoodsExchange', goodsItem)
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-list-container {
  padding: 0 0 0.22rem;
  .title {
    font-size: 0.28rem;
    color: #999;
    padding: 0 0 0.2rem;
  }
  .goods-wrap {
    display: flex;
    flex-flow: row wrap;
    .goods-item {
      width: 48%;
      margin-right: auto;
      box-sizing: border-box;
      margin-bottom: 0.24rem;
      background: #ffffff;
      &:nth-child(odd) {
        margin-right: auto;
      }
      &:nth-child(even) {
        margin-right: 0;
      }
    }
  }
}
</style>
